module.exports = __webpack_public_path__ + "static/media/3-2_Side_Attached_01.31096a3a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/printing-information/Printing-Techniques/3-2_Side_Attached_01.jpg
// module id = 1733
// module chunks = 0